import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentCategoryDto extends EpimsBaseEntityDto {

    IncidentCategoryId: string;

    IncidentCategoryName: string; 
      
    SubscriptionUserId: string;
    
    length : number;

}